import type { DueToPayReportComponentProps } from './DueToPayReportComponent';

export const DueToPayReportComponent = {
    MountAsync: async (target: HTMLElement, props: DueToPayReportComponentProps) => {
        const { mountReactComponentAsync } = await import('../../../js/mountReactComponentAsync');
        const { DueToPayReportComponent } = await import('./DueToPayReportComponent');
        return await mountReactComponentAsync(target, DueToPayReportComponent, props);
    }
};
